import apiClient from "./apiClient";
import { encryptData } from "../Authentication/encryption";
import { decryptData } from "../Authentication/decryptData";

const apiService = {
  get: async (endpoint, requestConfig = {}) => {
    const response = await apiClient.get(endpoint, requestConfig);
    return response.data;
  },

  post: async (
    endpoint,
    data = {},
    { encryptRequest = false, decryptResponse = false, ...requestConfig } = {},
  ) => {
    const payload = encryptRequest
      ? { encryptedData: encryptData(data) }
      : data;

    const response = await apiClient.post(endpoint, payload, requestConfig);

    return decryptResponse ? decryptData(response.data) : response.data;
  },

  put: async (
    endpoint,
    data = {},
    { encryptRequest = false, decryptResponse = false, ...requestConfig } = {},
  ) => {
    const payload = encryptRequest
      ? { encryptedData: encryptData(data) }
      : data;

    const response = await apiClient.put(endpoint, payload, requestConfig);

    return decryptResponse ? decryptData(response.data) : response.data;
  },

  patch: async (
    endpoint,
    data = {},
    { encryptRequest = false, decryptResponse = false, ...requestConfig } = {},
  ) => {
    const payload = encryptRequest
      ? { encryptedData: encryptData(data) }
      : data;

    const response = await apiClient.patch(endpoint, payload, requestConfig);

    return decryptResponse ? decryptData(response.data) : response.data;
  },

  delete: async (endpoint, requestConfig = {}) => {
    const response = await apiClient.delete(endpoint, requestConfig);
    return response.data;
  },
};

export default apiService;
